module.exports = __webpack_public_path__ + "img/huxi_des_4.7c2e4d19.jpg";